import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Collapse } from "reactstrap"
import { Link, withRouter, useHistory } from "react-router-dom"
import classname from "classnames"
import {
  getCurrentUser,
  getPermission,
  setCurrentUser,
  setFilterDate,
  setFilterDate2,
} from "../../helpers/Utils"
import axios from "axios"
import EditLeadModal from "../Lead/EditLeadModal"
import LocationModal from "../Admin/Location/LocationModal"
import MigrationModal from "../Migration"

import { withTranslation } from "react-i18next"

import { connect, useSelector } from "react-redux"
import Loader from "../Loader/loader"

const Navbar = props => {
  const [crm, setcrm] = useState(false)
  const [categorie, setcategorie] = useState(false)
  const [setting, setSetting] = useState(false)
  const [follow, setfollow] = useState(false)
  const [email, setemail] = useState(false)
  const [component, setcomponent] = useState(false)
  const [extra, setextra] = useState(false)
  const [modal_standard, setmodal_standard] = useState(false)
  const [modal2, setmodal2] = useState(false)
  const [migration_modal, setmigration_modal] = useState(false)
  const [branches, setBranches] = useState([])
  const [branch, setBranch] = useState([])
  const [selectedBranch, setSelectedBranch] = useState(
    localStorage.getItem("selectedBranch") || null
  )
  const [error2, setError2] = useState("")
  const [branchData, setBranchData] = useState(null)
  const [loader, setLoader] = useState(<Loader />)
  const [counter, setCounter] = useState("")
  const [user_id, setUser_id] = useState(getCurrentUser().id)
  const [dashboardData, setDashboardData] = useState(null)
  const [refreshapi, setRefreshApi] = useState(false)
  const [branchManagers, setBranchManagers] = useState([])
  const dashboardCounter = useSelector(state => state.data.apiData)

  useEffect(() => {
    if (dashboardCounter) {
      setCounter(dashboardCounter)
    }
  }, [dashboardCounter])

  useEffect(() => {
    if (refreshapi) {
      getAllCounters()
      setRefreshApi(false)
    }
  }, [refreshapi])

  useEffect(() => {
    const currentUserId = getCurrentUser()?.id
    if (currentUserId && currentUserId !== user_id) {
      setUser_id(currentUserId)
      getAllCounters()
    }
  }, [user_id])

  useEffect(() => {
    const storedCounters = localStorage.getItem("NavCounters")
    if (storedCounters) {
      const parsedCounters = JSON.parse(storedCounters)
      setCounter(parsedCounters)
    }

    const currentUser = getCurrentUser()
    if (currentUser && currentUser.token) {
      getAllCounters()
    }
  }, [])

  useEffect(() => {
    const storedData = localStorage.getItem("DashboardData")
    if (storedData) {
      const parsedData = JSON.parse(storedData)
      setDashboardData(parsedData)
      if (parsedData?.branch_managers) {
        setBranchManagers(parsedData.branch_managers)
      }
    }
  }, [])
  useEffect(() => {
    if (getCurrentUser().enable_branch == 1) {
      if (branchManagers?.length > 0) {
        const manager = branchManagers.find(manager => manager.id === user_id)

        if (manager && manager.branch_assignee) {
          setBranch(manager.branch_assignee)
        }
      }
    }
  }, [dashboardData, branchManagers, user_id])

  const history = useHistory()

  const getAllCounters = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/all-counter?lms_active=${
          getCurrentUser().crm_permission == 0 &&
          getCurrentUser().crmpro_permission == 0
            ? 1
            : 0
        }`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setCounter(res.data.data)
          localStorage.setItem("NavCounters", JSON.stringify(res.data.data))
        } else {
          setCounter("")
          if (res.data.message === "Unauthenticated.") {
            setCurrentUser("")
            localStorage.setItem("DashboardData", "")
            history.push("/login")
          } else {
          }
        }
      })
      .catch(err => {
        setCurrentUser("")
        history.push("/login")
      })
  }

  const showAllBranch = () => {
    setLoader(true)
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/branch`,
        {
          headers: {
            Authorization: `Bearer ${getCurrentUser().token || ""}`,
          },
        }
      )
      .then(res => {
        setLoader(false)
        if (res.data.status) {
          setBranches(res.data.data)
          localStorage.setItem("showBranch", JSON.stringify(res.data.data))
        } else {
          setError2(res.data.message)
        }
      })
      .catch(err => {
        setError2("Failed to fetch branches.")
      })
  }

  const showBranch = id => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/branch/${id}`,
        {
          headers: {
            Authorization: `Bearer ${getCurrentUser().token || ""}`,
          },
        }
      )
      .then(res => {
        if (res.data.status) {
          setSelectedBranch(res.data.data)
          localStorage.setItem("selectedBranch", id || "")
          setBranchData(res.data.data)
        } else {
          setError2(res.data.message)
        }
      })
      .catch(() => {
        setError2("Failed to fetch branch data.")
      })
  }

  useEffect(() => {
    const storedCounters = localStorage.getItem("NavCounters")
    if (storedCounters) {
      const parsedCounters = JSON.parse(storedCounters)
      setCounter(parsedCounters)
    }

    const currentUser = getCurrentUser()
    if (currentUser && currentUser.token) {
      getAllCounters()
    }
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)
    const type = params.get("statistics")
    if (type === "1") {
      localStorage.setItem("leadAmount", "")
      setFilterDate({
        from: "",
        to: "",
      })
      setFilterDate2({
        from: "",
        to: "",
      })
      localStorage.setItem("leadMessage", "")
      localStorage.setItem("deadStatus", "")
      localStorage.setItem("latestMessage", "")
      localStorage.setItem("leadRole", "")
      localStorage.setItem("leadEmail", "")
      localStorage.setItem("leadStatus2", "")
      localStorage.setItem("leadDay", "")
      localStorage.setItem("leadStatus3", "")
      localStorage.setItem("leadmaturedby", "")
      localStorage.setItem("ledgerType", "")
      localStorage.setItem("offerType", "")
      localStorage.setItem("PrductGST", "")
      localStorage.setItem("OrderStatus", "")
      localStorage.setItem("OrderPstatus", "")
      localStorage.setItem("leadSort", "")
      localStorage.setItem("leadID", "")
      localStorage.setItem("leadMatured_at", "")
      localStorage.setItem(
        "leadAssigned_at",
        JSON.stringify({
          startDate: "",
          endDate: "",
        })
      )
      localStorage.setItem("current_page", "")
      localStorage.setItem("leadAction", "")
      localStorage.setItem("leadRestored", "")
      localStorage.setItem("logType", "")
      localStorage.setItem("leadfields_filter", JSON.stringify({ data: "" }))
    } else {
      localStorage.setItem("leadHolder", "")
      localStorage.setItem("leadLabel", "")
      localStorage.setItem("leadStatus", "")
      localStorage.setItem("leadTag", "")
      localStorage.setItem("leadName", "")
      localStorage.setItem("leadContact", "")
      localStorage.setItem("leadSource", "")
      localStorage.setItem("leadAmount", "")
      setFilterDate({
        from: "",
        to: "",
      })
      setFilterDate2({
        from: "",
        to: "",
      })
      localStorage.setItem("leadMessage", "")
      localStorage.setItem("followupStatus", "")
      localStorage.setItem("matureStatus", "")
      localStorage.setItem("deadReason", "")
      localStorage.setItem("deadStatus", "")
      localStorage.setItem("latestMessage", "")
      localStorage.setItem("leadRole", "")
      localStorage.setItem("leadEmail", "")
      localStorage.setItem("leadStatus2", "")
      localStorage.setItem("leadDay", "")
      localStorage.setItem("leadStatus3", "")
      localStorage.setItem("leadmaturedby", "")
      localStorage.setItem("ledgerType", "")
      localStorage.setItem("offerType", "")
      localStorage.setItem("PrductGST", "")
      localStorage.setItem("OrderStatus", "")
      localStorage.setItem("OrderPstatus", "")
      localStorage.setItem("leadSort", "")
      localStorage.setItem("leadID", "")
      localStorage.setItem("leadTransfer", "")
      localStorage.setItem("leadFlag", "")
      localStorage.setItem("leadUpdateSince", "")
      localStorage.setItem("leadOrderSince", "")
      localStorage.setItem("leadPaymentSince", "")
      localStorage.setItem("leadFirmName", "")
      localStorage.setItem("leadCreated_at", "")
      localStorage.setItem("leadMatured_at", "")
      localStorage.setItem("updatedBy", "")
      localStorage.setItem(
        "leadAssigned_at",
        JSON.stringify({
          startDate: "",
          endDate: "",
        })
      )
      localStorage.setItem("current_page", "")
      localStorage.setItem("leadAction", "")
      localStorage.setItem("leadAssigned", "")
      localStorage.setItem("CompanyPool", "")
      localStorage.setItem("leadfields_filter", JSON.stringify({ data: "" }))
      localStorage.setItem(
        "leadImportant_date",
        JSON.stringify({
          from: "",
          to: "",
        })
      )
    }
  }, [branchData])

  useEffect(() => {
    const savedBranchId = localStorage.getItem("selectedBranch")
    if (savedBranchId && !branchData) {
      showBranch(savedBranchId)
    }
  }, [branchData])

  const handleBranchChange = id => {
    if (id === "") {
      setSelectedBranch(null)
      localStorage.setItem("selectedBranch", "")
      setBranchData(null)
      setTimeout(() => {
        window.location.reload()
      }, 0)
    } else {
      showBranch(id)
      setTimeout(() => {
        window.location.reload()
      }, 1500)
    }
  }

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    for (var i = 0; i < items.length; ++i) {
      if (props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })
  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  useEffect(() => {
    const storedData = localStorage.getItem("DashboardData")

    if (!storedData) {
      getAllCounters()
      if (getCurrentUser().enable_branch == 1) {
        showAllBranch()
      }
    }
  }, [])

  return (
    <React.Fragment>
      {modal_standard ? (
        <EditLeadModal
          modal_standard={modal_standard}
          setmodal_standard={setmodal_standard}
          module="general_lead"
        />
      ) : (
        ""
      )}
      {modal2 ? <LocationModal modal2={modal2} setmodal2={setmodal2} /> : ""}
      {migration_modal ? (
        <MigrationModal
          migration_modal={migration_modal}
          setmigration_modal={setmigration_modal}
        />
      ) : (
        ""
      )}
      <div
        className="topnav"
        style={{
          marginTop: `${
            getCurrentUser()?.expiry_message !== null ? "18px" : "0px"
          }`,
        }}
      >
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul
                className={`navbar-nav w-100 ${
                  getCurrentUser()?.expiry_message !== null
                    ? "margin-top-24"
                    : ""
                }`}
              >
                <li className="nav-item">
                  <Link className="nav-link" to="/dashboard">
                    <i className="ti-bar-chart me-2" />
                    {props.t("Dashboard")} {props.menuOpen}
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    onClick={e => {
                      e.preventDefault()
                      setfollow(!follow)
                    }}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="ti-harddrives me-2"></i>
                    {props.t("Follow Ups")}
                  </Link>
                  <div className={classname("dropdown-menu", { show: follow })}>
                    <div className="dropdown">
                      <Link to="/followups-today" className="dropdown-item">
                        {props.t("Today's Followup")}{" "}
                        <span className="text-primary">
                          ({counter && counter.today_followup})
                        </span>
                      </Link>
                    </div>
                    <div className="dropdown">
                      <Link to="/followups-future" className="dropdown-item">
                        {props.t("Future Followup")}{" "}
                        <span className="text-primary">
                          ({counter && counter.future_followup})
                        </span>
                      </Link>
                    </div>
                  </div>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    onClick={e => {
                      e.preventDefault()
                      setcomponent(!component)
                    }}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="ti-harddrives me-2"></i>
                    {props.t("Leads")}
                  </Link>
                  <div
                    className={classname("dropdown-menu", {
                      show: component,
                    })}
                  >
                    <div className="dropdown">
                      {getPermission() &&
                      getPermission().lead.lead.create.is_checked === "yes" ? (
                        <span
                          onClick={() => setmodal_standard(true)}
                          className="dropdown-item"
                          style={{ cursor: "pointer" }}
                        >
                          {props.t("Add New Lead")}
                        </span>
                      ) : (
                        ""
                      )}
                      {getCurrentUser()?.role_name === "Administrator" ||
                      getCurrentUser()?.role_name === "Sub Administrator" ? (
                        <Link to="/statistics" className="dropdown-item">
                          {props.t("All Stats")}{" "}
                          <span className="text-primary">
                            ({counter && counter.all_leads})
                          </span>
                        </Link>
                      ) : (
                        ""
                      )}
                      <Link to="/leads?id=&reload=1" className="dropdown-item">
                        {props.t("All Leads")}{" "}
                        <span className="text-primary">
                          ({counter && counter.all_leads})
                        </span>
                      </Link>
                      {getPermission() &&
                      getPermission().repeated_lead.repeated_lead.view
                        .is_checked === "yes" ? (
                        <Link to="/repeated-leads" className="dropdown-item">
                          {props.t("Repeated Leads")}{" "}
                          <span className="text-primary">
                            ({counter && counter.repeated_leads})
                          </span>
                        </Link>
                      ) : (
                        ""
                      )}
                      {getPermission() &&
                      getPermission().repeated_lead.repeated_lead.view
                        .is_checked === "yes" ? (
                        <Link to="/duplicated-leads" className="dropdown-item">
                          {props.t("Duplicated Leads")}{" "}
                          <span className="text-primary">
                            ({counter && counter.duplicate})
                          </span>
                        </Link>
                      ) : (
                        ""
                      )}
                      {getPermission() &&
                      getPermission().company_pool.company_pool.view
                        .is_checked === "yes" ? (
                        <Link to="/company-leads" className="dropdown-item">
                          {props.t("Company Pool")}{" "}
                          <span className="text-primary">
                            ({counter && counter.company_pool})
                          </span>
                        </Link>
                      ) : (
                        ""
                      )}
                      <Link to="/transfer-request" className="dropdown-item">
                        {props.t("Transfer Request")}{" "}
                        <span className="text-primary">
                          ({counter && counter.transfer_request})
                        </span>
                      </Link>
                      {getPermission() &&
                      getPermission().my_lead.my_lead.view.is_checked ===
                        "yes" ? (
                        <>
                          {getCurrentUser()?.role_name == "Executive" ? (
                            ""
                          ) : (
                            <Link to="/my-leads" className="dropdown-item">
                              {props.t("My Leads")}{" "}
                              <span className="text-primary">
                                ( {counter && counter.my_leads})
                              </span>
                            </Link>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      {getPermission() &&
                      getPermission().deleted_lead.deleted_lead.view
                        .is_checked === "yes" ? (
                        <Link to="/deleted-leads" className="dropdown-item">
                          {props.t("Trashed Leads")}{" "}
                          <span className="text-primary">
                            ({counter && counter.deleted_leads})
                          </span>
                        </Link>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to="/occupied-locations">
                    <i className="ti-archive me-2"></i>{" "}
                    {props.t("Occupied Locations")} {props.menuOpen}
                  </Link>
                </li>

                {getPermission()?.dead_request_lead?.dead_request_lead?.view
                  ?.is_checked === "yes" ||
                getPermission()?.dead_lead?.dead_lead?.view?.is_checked ===
                  "yes" ||
                getPermission()?.winback_pool?.winback_pool?.view
                  ?.is_checked === "yes" ? (
                  <li className="nav-item dropdown">
                    <Link
                      to="/#"
                      className="nav-link dropdown-toggle arrow-none"
                      onClick={e => {
                        e.preventDefault()
                        setextra(!extra)
                      }}
                    >
                      <i className="ti-support me-2"></i>{" "}
                      {props.t("Dead Leads")}
                    </Link>
                    <div
                      className={classname(
                        "dropdown-menu mega-dropdown-menu px-2 dropdown-mega-menu",
                        {
                          show: extra,
                        }
                      )}
                    >
                      <div className="row">
                        <div className="col-lg-6">
                          <div>
                            {getPermission() &&
                            getPermission().dead_request_lead.dead_request_lead
                              .view.is_checked === "yes" ? (
                              <Link
                                to="/dead-requests"
                                className="dropdown-item"
                              >
                                {props.t("Requests")}{" "}
                                <span className="text-primary">
                                  ({counter && counter.dead_request_leads})
                                </span>
                              </Link>
                            ) : (
                              ""
                            )}
                            {getPermission() &&
                            getPermission().dead_lead.dead_lead.view
                              .is_checked === "yes" ? (
                              <Link to="/dead-leads" className="dropdown-item">
                                {props.t("Dead")}{" "}
                                <span className="text-primary">
                                  ({counter && counter.dead_leads})
                                </span>
                              </Link>
                            ) : (
                              ""
                            )}
                            {getPermission() &&
                            getPermission().winback_pool.winback_pool.view
                              .is_checked === "yes" ? (
                              <Link
                                to="/winback-leads"
                                className="dropdown-item"
                              >
                                {props.t("Win Back Pool")}{" "}
                                <span className="text-primary">
                                  ({counter && counter.winback_pool})
                                </span>
                              </Link>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                ) : (
                  ""
                )}

                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="/#"
                    id="topnav-emailtemplates"
                    role="button"
                    onClick={e => {
                      e.preventDefault()
                      setemail(!email)
                    }}
                  >
                    <i className="ti-bookmark-alt me-2"></i>Daily Report
                  </Link>
                  <div
                    className={classname("dropdown-menu", {
                      show: email,
                    })}
                    aria-labelledby="topnav-emailtemplates"
                  >
                    <Link to="/today-report" className="dropdown-item">
                      {props.t("Today's Report")}{" "}
                    </Link>
                    <Link to="/past-report" className="dropdown-item">
                      {props.t("Past 30 Days Reports")}{" "}
                    </Link>
                    {getCurrentUser()?.role_name === "Administrator" ? (
                      <Link to="/activity-logs" className="dropdown-item">
                        {props.t("Activity log")}{" "}
                      </Link>
                    ) : (
                      ""
                    )}
                  </div>
                </li>

                {getCurrentUser().crm_permission ||
                getCurrentUser().crmpro_permission == 1 ||
                getCurrentUser().crmpronew_permission == 1 ? (
                  <li className="nav-item dropdown">
                    <Link
                      to="/#"
                      onClick={e => {
                        e.preventDefault()
                        setcrm(!crm)
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                    >
                      <i className="fas fa-users  me-2"></i>
                      {props.t("CRM")}
                    </Link>
                    <div className={classname("dropdown-menu", { show: crm })}>
                      <div className="dropdown">
                        <Link to="/customers" className="dropdown-item">
                          {props.t("Customers")}{" "}
                        </Link>
                      </div>
                      <div className="dropdown">
                        <Link
                          to="/#"
                          onClick={e => {
                            e.preventDefault()
                            setcategorie(!categorie)
                          }}
                          className="dropdown-item"
                        >
                          {props.t("Categories")}{" "}
                          <div className="arrow-down"></div>
                        </Link>
                        <div
                          // className="dropdown-menu"
                          className={classname("dropdown-menu", {
                            show: categorie,
                          })}
                        >
                          <div className="dropdown">
                            <Link to="/all-category" className="dropdown-item">
                              {props.t("All Categories")}{" "}
                            </Link>
                          </div>
                          <div className="dropdown">
                            <Link to="/sub-category" className="dropdown-item">
                              {props.t("Sub-Categories")}{" "}
                            </Link>
                          </div>
                          <div className="dropdown">
                            <Link to="/all-packing" className="dropdown-item">
                              {props.t("All Packing")}{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="dropdown">
                        <Link to="/orders" className="dropdown-item">
                          {props.t(
                            getCurrentUser()?.crm_order_title
                              ? getCurrentUser()?.crm_order_title
                              : "Orders"
                          )}{" "}
                        </Link>
                      </div>
                      <div className="dropdown">
                        <Link to="/ledgers" className="dropdown-item">
                          {props.t("Ledger")}{" "}
                        </Link>
                      </div>
                      <div className="dropdown">
                        <Link to="/proformas" className="dropdown-item">
                          {props.t(
                            getCurrentUser()?.crm_proforma_title
                              ? getCurrentUser()?.crm_proforma_title
                              : "Proformas"
                          )}{" "}
                        </Link>
                      </div>
                      {getCurrentUser().crmpro_products_enabled == 1 ? (
                        <div className="dropdown">
                          <Link to="/products" className="dropdown-item">
                            {props.t("Product List")}{" "}
                          </Link>
                        </div>
                      ) : (
                        ""
                      )}
                      {getCurrentUser().crmpro_services_enabled == 1 ? (
                        <div className="dropdown">
                          <Link to="/product-line" className="dropdown-item">
                            {props.t("Service Line")}{" "}
                          </Link>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="dropdown">
                        <Link to="/offers" className="dropdown-item">
                          {props.t("Offers")}{" "}
                        </Link>
                      </div>
                      <div className="dropdown">
                        <Link to="/schemes" className="dropdown-item">
                          {props.t("Customer Schemes")}{" "}
                        </Link>
                      </div>
                      <div className="dropdown">
                        <Link to="/complaints" className="dropdown-item">
                          {props.t("Complaints")}{" "}
                        </Link>
                      </div>
                    </div>
                  </li>
                ) : (
                  ""
                )}
                {getPermission() &&
                getPermission().admin.admin.view.is_checked === "yes" ? (
                  <>
                    <li className="nav-item">
                      <Link
                        className="nav-link"
                        to="/settings"
                        // onClick={e => {
                        //   e.preventDefault()
                        //   setauth(!auth)
                        // }}
                      >
                        <i className="ti-user me-2"></i>{" "}
                        {props.t("Admin Settings")} {props.menuOpen}
                      </Link>
                    </li>

                    {getCurrentUser().enable_branch == 1 ? (
                      <>
                        {" "}
                        <li className="nav-item">
                          <Link className="nav-link">
                            <select
                              style={{
                                display: "inline-block",
                                width: "auto",
                                background: "transparent",
                                border: "none",
                                color: "inherit",
                                outline: "none",
                                fontSize: "inherit",
                              }}
                              value={selectedBranch?.id || ""}
                              onChange={e => {
                                const selectedId = e.target.value
                                handleBranchChange(selectedId)
                              }}
                            >
                              <option
                                style={{ color: "lightseagreen" }}
                                value=""
                              >
                                All Branches
                              </option>
                              {branches &&
                                branches.map(branch => (
                                  <option
                                    style={{ color: "lightseagreen" }}
                                    key={branch.id}
                                    value={branch.id}
                                  >
                                    {branch.name}
                                  </option>
                                ))}
                            </select>
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
                {getCurrentUser()?.role_name === "Branch Manager" ? (
                  <>
                    <li className="nav-item">
                      <Link
                        className="nav-link"
                        to="/settings"
                        // onClick={e => {
                        //   e.preventDefault()
                        //   setauth(!auth)
                        // }}
                      >
                        <i className="ti-user me-2"></i>{" "}
                        {props.t("Admin Settings")} {props.menuOpen}
                      </Link>
                    </li>

                    {getCurrentUser().enable_branch == 1 &&
                    branch?.length > 1 ? (
                      <>
                        {" "}
                        <li className="nav-item">
                          <Link className="nav-link">
                            <select
                              style={{
                                display: "inline-block",
                                width: "auto",
                                background: "transparent",
                                border: "none",
                                color: "inherit",
                                outline: "none",
                                fontSize: "inherit",
                              }}
                              value={selectedBranch?.id || ""}
                              onChange={e => {
                                const selectedId = e.target.value
                                handleBranchChange(selectedId)
                              }}
                            >
                              <option
                                style={{ color: "lightseagreen" }}
                                value=""
                              >
                                All Branches
                              </option>
                              {branch &&
                                branch.map(branche => (
                                  <option
                                    style={{ color: "lightseagreen" }}
                                    key={branche?.branch.id}
                                    value={branche?.branch.id}
                                  >
                                    {branche?.branch.name}
                                  </option>
                                ))}
                            </select>
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
                {getCurrentUser()?.role_name !== "Administrator" &&
                getCurrentUser()?.role_name !== "Branch Manager" ? (
                  getPermission()?.lead_label.lead_label.view.is_checked ===
                    "yes" ||
                  getPermission()?.lead_source.lead_source.view.is_checked ===
                    "yes" ? (
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={e => {
                          e.preventDefault()
                          setSetting(!setting)
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="fa fa-cog me-2"></i>
                        {props.t("Settings")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: setting,
                        })}
                      >
                        {getPermission() &&
                        getPermission().lead_label.lead_label.view
                          .is_checked === "yes" ? (
                          <div className="dropdown">
                            <Link to="/lead-source" className="dropdown-item">
                              {props.t("Lead Source")}{" "}
                              <span className="text-primary">
                                {/* ({counter?.today_followup}) */}
                              </span>
                            </Link>
                          </div>
                        ) : (
                          ""
                        )}
                        {getPermission() &&
                        getPermission().lead_source.lead_source.view
                          .is_checked === "yes" ? (
                          <div className="dropdown">
                            <Link to="/lead-label" className="dropdown-item">
                              {props.t("Lead Label")}{" "}
                              <span className="text-primary"></span>
                            </Link>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </li>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
)
